module.exports = __webpack_public_path__ + "static/media/background-purple.5a3bb9e9.jpg";